export default __webpack_public_path__ + "static/char-s-35-zh-Hant-a681be9e0196392e4e3cdc47db55bf2b.webp";